<template>
  <div>
    <p v-for="line in lines" :key="line">
      {{ line }}
    </p>
  </div>
</template>

<script>
export default {
    props: {
        text: String,
    },
    computed: {
        lines () {
            return this.text.split('@@')
        },
    },
}
</script>
